import { FC } from "react";
import { IconPropsType } from ".";

export const TurnUp: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 15H6.5C8 15 11 14.1 11 10.5C11 6.9 11 4.66667 11 4M11 4L8 7M11 4L14 7M8 1H14"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
